export const PageTitleAndDesc = ({
  title,
  description,
  icon
}: {
  title: string;
  description: string;
  icon?: React.ReactNode;
}) => {
  return (
    <div className="mb-6">
      <div className="flex items-center gap-2">
        {icon}
        <h1 className={"!border-b-0 font-bold text-3xl"}>{title}</h1>
      </div>
      <p className="text-md text-muted-foreground">{description}</p>
    </div>
  );
};
